
const getAcceptChildren = (domain: string) => {
    if (domain.includes("yoonly")) {
        return false;
    }
    return true;
}

export default getAcceptChildren;
